import React from 'react'
import OneboxTemplateDefault from 'src/components/template/onebox/canada'
import { videos } from 'src/constants/videos'
import { getURIParamValue } from 'src/modules/utils/analytics'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'
import { subtitleText } from 'src/modules/utils/constants'
export default (props) => {
  const urlSeason = getURIParamValue(props.location.search, 'season')

  const videoUrlSubfolder = urlSeason ? urlSeason : 'eplca'

  return (
    <OneboxTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      video={videos.canada_epl.videoUrl}
      videoUrlBase={'https://marketing-partners.fubo.tv/wsc/' + videoUrlSubfolder + '/'}
      title="Watch Premier League All Season"
      subtitle={subtitleText.epl}
      networkSet="canada_sports"
      customNetworks={['fsn']}
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress"
      logoHeight="90px"
      planCardsConfig={{
        plans: canadaPlanSet.sports,
        overrides: canadaSports_EPL_UCL_Override,
      }}
    />
  )
}
